import { render, staticRenderFns } from "./ApprovalInsertTransaction.vue?vue&type=template&id=68ce1d62&scoped=true"
import script from "./ApprovalInsertTransaction.vue?vue&type=script&lang=js"
export * from "./ApprovalInsertTransaction.vue?vue&type=script&lang=js"
import style0 from "./ApprovalInsertTransaction.vue?vue&type=style&index=0&id=68ce1d62&prod&lang=css"
import style1 from "./ApprovalInsertTransaction.vue?vue&type=style&index=1&id=68ce1d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ce1d62",
  null
  
)

export default component.exports